import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  ExtensionText, FileContainer, Link, NameTitle, LinkDelete, ContainerLinks,
} from './styles';

import ModalDelete from './modal-delete';

const AttachmentFile = (props) => {
  const {
    file,
    filePath,
    projectId,
    id,
    refetch,
  } = props;
  // remove the extension and the get the file name
  const [fileName, fileExtension] = [file.split('_').slice(1).join('_').split('.')
    .slice(0, -1)
    .join('.'), `.${file.split('.').pop()}`];

  const [open, setOpen] = useState(false);

  const handleViewClick = () => {
    if (fileExtension === '.pdf') {
      window.open(filePath, '_blank');
    } else {
      window.open(`/projects/${projectId}/attachments/${id}`, '_blank');
    }
  };
  const handleDeleteClick = () => {
    setOpen(true);
  };

  return (
    <>
      <FileContainer>
        <NameTitle data-file-name={fileName}>{fileName}</NameTitle>
        <ExtensionText>{fileExtension}</ExtensionText>
        <ContainerLinks>
          <Link onClick={handleViewClick}>View</Link>
          <LinkDelete onClick={handleDeleteClick}>Delete</LinkDelete>
        </ContainerLinks>
      </FileContainer>
      <ModalDelete
        open={open}
        onClose={() => setOpen(false)}
        id={id}
        refetch={refetch}
      />
    </>
  );
};

AttachmentFile.propTypes = {
  file: PropTypes.string.isRequired,
  filePath: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default AttachmentFile;
